/**
 * A boolean custom column is never a dropdown (#15575). Its value is already
 * Yes or No; a dropdown flag on one made the record page store the word "Yes",
 * which the grid reads as No, and the column routes now refuse it.
 */

type ColumnLike = {
  data_type: string;
  is_enum?: boolean;
  scalar_values?: string[] | null;
  enum_colors?: Record<string, string> | null;
  is_array?: boolean;
};

/** Whether a column of this data type may carry the dropdown flag. */
export const canBeDropdown = (dataType: string): boolean =>
  dataType !== "boolean" && dataType !== "entity";

/**
 * The column as a columns save sends it: a boolean column without the
 * dropdown flag, its options, their colours or multi-select. A column
 * configured that way before the fix is cleared by the next save of the list
 * rather than refused by the server.
 */
export const withoutBooleanDropdown = <T extends ColumnLike>(column: T): T =>
  column.data_type === "boolean"
    ? {
        ...column,
        is_enum: false,
        scalar_values: undefined,
        enum_colors: undefined,
        is_array: false,
      }
    : column;
